import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentRefererGet = {
    path: "/consent/referer",
    method: RouteHttpVerb.GET
};
export { locationRestConsentRefererGet };
